var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.983 13.342C26.988 13.228 27 13.116 27 13C27 8.582 23.418 5 19 5C15.89 5 13.2 6.779 11.877 9.371C11.296 9.136 10.665 9 10 9C7.47 9 5.401 10.885 5.068 13.324C2.703 14.129 1 16.363 1 19C1 22.314 3.686 25 7 25H25C28.314 25 31 22.314 31 19C31 16.382 29.321 14.162 26.983 13.342ZM12.293 16.293L15.293 13.293C15.488 13.098 15.744 13 16 13C16.256 13 16.512 13.098 16.707 13.293L19.707 16.293C20.098 16.684 20.098 17.316 19.707 17.707C19.316 18.098 18.684 18.098 18.293 17.707L17 16.414V29C17 29.552 16.553 30 16 30C15.447 30 15 29.552 15 29V16.414L13.707 17.707C13.316 18.098 12.684 18.098 12.293 17.707C11.902 17.316 11.902 16.684 12.293 16.293Z",
    fill: "#365EDE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6930a5fe.svg";
export { ForwardRef as ReactComponent };